import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import { getMe } from './services/userService';
import { getUserFromToken } from './utils/auth/tokenService';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';

// Pages Imports
import Navbar from './components/main/Navbar/Navbar';
import Footer from './components/main/Footer/Footer';
import Scroll from './components/main/buttons/Scroll/Scroll';

import Home from './pages/main/Home/Home';
import OurProcess from './pages/main/about-us/OurProcess/OurProcess';
import OurTeam from './pages/main/about-us/OurTeam/OurTeam';
import Faq from './pages/main/about-us/Faq/Faq';
import OurServices from './pages/main/services/OurServices/OurServices';
import ConditionsTreated from './pages/main/services/ConditionsTreated/ConditionsTreated';
import Rates from './pages/main/Rates/Rates';
import ContactUs from './pages/main/ContactUs/ContactUs';
import Products from './pages/main/Products/Products';
import Blog from './pages/main/Blog/Blog';
import BlogAuthor from './pages/main/BlogAuthor/BlogAuthor';
import BlogCategory from './pages/main/BlogCategory/BlogCategory';
import BlogPostDetail from './pages/main/BlogPostDetail/BlogPostDetail';
import FreeConsultation from './pages/main/FreeConsultation/FreeConsultation';

//ADMIN IMPORTS
import AdminTopBar from './components/admin/AdminTopBar/AdminTopBar';
import AdminNav from './components/admin/AdminNav/AdminNav';
import AdminConditions from './pages/admin/AdminConditions/AdminConditions';
import AdminPrices from './pages/admin/AdminPrices/AdminPrices';
import AdminFaqs from './pages/admin/AdminFaqs/AdminFaqs';
import AdminProducts from './pages/admin/AdminProducts/AdminProducts';
import AdminServices from './pages/admin/AdminServices/AdminServices';
import AdminTeamMembers from './pages/admin/AdminTeamMembers/AdminTeamMembers';
import AdminBlog from './pages/admin/AdminBlog/AdminBlog';
import AdminBlogMetadata from './pages/admin/AdminBlogMetadata/AdminBlogMetadata';
import AdminUsers from './pages/admin/AdminUsers/AdminUsers';

function App() {
  const [currentUser, setCurrentUser] = useState(getUserFromToken());
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);

  const mainContentRef = useRef(null);

  const sideBarWidth = isSideBarOpen ? 'side-bar-open' : 'side-bar-close';
  const mainPadding = isSideBarOpen ? 'main-shrink' : 'main-expand';

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        const user = await getMe();
        setCurrentUser(user);
      } catch (err) {
        console.error({ err });
        setCurrentUser(null);
      }
    };

    const userFromToken = getUserFromToken();
    if (!userFromToken) return;

    getCurrentUser();
  }, []);

  return (
    <div className='App'>
      {!currentUser ? (
        <header className='App-header'>
          <Navbar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/our-process' element={<OurProcess />} />
            <Route path='/our-team' element={<OurTeam />} />
            <Route path='/faq' element={<Faq />} />
            <Route path='/our-services' element={<OurServices />} />
            <Route path='/conditions' element={<ConditionsTreated />} />
            <Route path='/rates' element={<Rates />} />
            <Route path='/contact-us' element={<ContactUs />} />
            <Route path='/products' element={<Products />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:slug' element={<BlogPostDetail />} />
            <Route path='/blog/author/:slug' element={<BlogAuthor />} />
            <Route path='/blog/category/:slug' element={<BlogCategory />} />
            <Route path='/free-consultation' element={<FreeConsultation />} />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
          <Footer className='footer' setCurrentUser={setCurrentUser} />
        </header>
      ) : (
        <header className='admin-container'>
          <div id='header'>
            <AdminTopBar
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
            />
          </div>
          <div id='admin-content'>
            <div id='sidebar' className={sideBarWidth}>
              <AdminNav
                isOpen={isSideBarOpen}
                setIsOpen={setIsSideBarOpen}
                toggle={() => {
                  setIsSideBarOpen((prev) => !prev);
                }}
              />
            </div>
            <div id='main' className={mainPadding} ref={mainContentRef}>
              <Routes>
                <Route
                  path='/admin/'
                  element={
                    <AdminUsers replace to='/admin' currentUser={currentUser} />
                  }
                />
                <Route
                  path='/admin/conditions'
                  element={<AdminConditions replace to='/admin' />}
                />
                <Route
                  path='/admin/prices'
                  element={<AdminPrices replace to='/admin' />}
                />
                <Route
                  path='/admin/faq'
                  element={
                    <AdminFaqs replace to='/admin' currentUser={currentUser} />
                  }
                />
                <Route
                  path='/admin/products'
                  element={<AdminProducts replace to='/admin' />}
                />
                <Route
                  path='/admin/services'
                  element={<AdminServices replace to='/admin' />}
                />
                <Route
                  path='/admin/team-members'
                  element={<AdminTeamMembers replace to='/admin' />}
                />
                <Route
                  path='/admin/blog'
                  element={
                    <AdminBlog
                      replace
                      to='/admin'
                      scrollContainerRef={mainContentRef}
                    />
                  }
                />
                <Route
                  path='/admin/blog-metadata'
                  element={<AdminBlogMetadata replace to='/admin' />}
                />
                <Route path='*' element={<Navigate to='/admin/' replace />} />
              </Routes>
            </div>
          </div>
        </header>
      )}
      {!currentUser ? (
        <div>
          <Scroll />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default App;
